export const ADMIN_MANAGEMENT_CONSTANTS = {
    DEFAULT_USERS_PER_PAGE: 7,
    DEFAULT_FAST_PAGE_JUMP: 10,
    SNACKBAR_DURATION: 6000,
   
    MESSAGES: {
      ADMIN_UPDATED_SUCCESS: 'Admin information, roles, and municipalities updated successfully!',
      ADMIN_CREATED_SUCCESS: 'Admin created successfully!',
      PASSWORD_CHANGED_SUCCESS: 'Password changed successfully!',
      ADMIN_DELETED_SUCCESS: 'Administration user deleted successfully.',
      AVATAR_UPLOADED_SUCCESS: 'Avatar uploaded successfully.',
      ALL_MUNICIPALITIES_ASSIGNED_SUCCESS: 'All available municipalities assigned successfully.',
      ALL_MUNICIPALITIES_REMOVED_SUCCESS: 'All municipalities removed successfully.',
      PASSWORD_MISMATCH_ERROR: 'New password must match!',
      SELECT_ADMIN_FIRST: 'Please make sure to select an administrator user first.',
      CONFIRM_DELETE: 'Are you sure you want to delete this admin?'
    }
  } as const;